module.exports = __webpack_public_path__ + "static/salon-407de990c1d70a8401b4fec0dab7a4cb.webp";